import { Injectable, ChangeDetectorRef } from '@angular/core';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Client } from 'src/providers/client/client';
import { BehaviorSubject } from 'rxjs';
import { HttpClientCustom } from 'src/providers/custom/http-client';
import { WindowService } from 'src/shared/providers/window.service';
import { AboutThisPageService } from 'src/providers/about-this-page/about-this-page.service';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

@Injectable({
  providedIn: 'root'
})

export class OnboardingProvider {

    showOnboarding = true;
    private _flow: string;
    private _page: string;
    private onboardingRequestId = 0;
    title: string;
    subTitle: string;
    priorPages: string[];
    showBackButton: boolean;
    hasProperties: boolean;
    showOnboardingInHeader$ = new BehaviorSubject<boolean>(false);
    showOnboardingOnPage$ = new BehaviorSubject<boolean>(false);
    showOnboardingInDashboard$ = new BehaviorSubject<boolean>(false);
    pageChanged$ = new BehaviorSubject<void>(undefined);
    flowChanged$ = new BehaviorSubject<void>(undefined);
    shouldShowAddProperty: boolean;
    showPrimaryModal = false;
    showedPrimaryModalOnFirstLoad = false;
    description: string;
    buttonText: string;
    loaded: boolean;
    previousOnboardingFlow: string;
    agentEnabled: boolean;

    get flow(): string {
      return this._flow;
    }

    set flow(value: string) {
      this._flow = value;
      this.flowChanged$.next();
    }

    get page(): string {
      return this._page;
    }

    set page(value: string) {
      this._page = value;
      this.pageChanged$.next();
    }

  constructor(
    private storage: TidyStorage,
    private client: Client,
    private httpClient: HttpClientCustom,
    private windowService: WindowService,
    private aboutThisPageService: AboutThisPageService
  ) {
    this.priorPages = [];
  }

  async refreshOnboardingContent() {
    this.priorPages = [];
    this.showBackButton = false;
    this.setOnboardingFlowText();
    const currentFlow = this.flow;
    this.hasProperties = await this.checkIfHasProperties();
    if (this.flow !== currentFlow) {
      return;
    }
    this.shouldShowAddProperty = this.checkIfShouldShowAddProperty();
    if (this.page !== 'agent') {
      if (this.shouldShowAddProperty) {
        this.page = 'property';
      } else {
        this.page = this.flow;
      }
    }
    if (this.shouldShowAddProperty) {
      this.setOnboardingFlowText();
    }
    if (this.page === 'agent' || this.flow === 'goals' || this.flow === 'createConciergeRules' || this.flow === 'selectAccessNotes'  ||this.flow === 'automateWorkflows' || this.flow === 'notifyProsOfChange' || this.flow === 'selectFindNewPros' || (this.flow === 'addPros' && !this.windowService.isDesktopRes)) {
      this.showedPrimaryModalOnFirstLoad = true;
      this.showPrimaryModal = true;
    } else {
      this.showedPrimaryModalOnFirstLoad = false;
      this.showPrimaryModal = false;
    }
  }

  checkIfShouldShowAddProperty() {
    const showPropertyFlows = ['toDos', 'inventoryAutomation', 'selectMaintenance', 'addPros', 'schedule', 'selectAccessNotes', 'enableAutomaticBooking'];
    return showPropertyFlows.includes(this.flow) && !this.hasProperties;
  }

  setOnboardingFlowText() {
    const translationPipe = new TranslationPipe();
    this.title = this.shouldShowAddProperty && this.flow !== 'schedule' ? 'Getting Started: Add Properties' : flowText[this.flow]?.title;
    if (!this.windowService.isDesktopRes) {
      this.title = this.title?.replace('Getting Started: ', '');
    }
    this.title = translationPipe.transform(this.title);
    const rawSubTitle = this.shouldShowAddProperty && this.flow !== 'schedule' ? flowText[this.flow]?.subTitleBeforeProperties : flowText[this.flow]?.subTitle;
    this.subTitle = translationPipe.transform(rawSubTitle);
    this.description = translationPipe.transform(flowText[this.flow]?.description);
    this.buttonText = translationPipe.transform(flowText[this.flow]?.buttonText);
  }

  goBack() {
    this.page = this.priorPages[this.priorPages.length - 1];
    this.priorPages.pop();
    if (this.priorPages.length === 0) {
      this.showBackButton = false;
    }
  }

  async showOnboardingIfFlowNotComplete(flow: string) {
    let showOnboarding = localStorage.getItem('showOnboarding') === 'true';
    if (!showOnboarding) {
      return this.showOnboarding = false;
    }
    if (flow === 'bills') {
      const shouldShow = this.aboutThisPageService.checkIfShouldShowAboutThisPage(flow);
      if (!shouldShow) {
        return this.showOnboarding = false;
      }
      this.flow = flow;
      this.page = flow;
      this.refreshOnboardingContent();
      this.setShowOnboardingOnPage(true);
      return this.showOnboarding = true;
    }
    if (flow === 'messageAutomation') {
      const shouldShow = this.aboutThisPageService.checkIfShouldShowAboutThisPage(flow);
      if (!shouldShow) {
        return this.showOnboarding = false;
      }
      this.flow = flow;
      this.page = flow;
      this.refreshOnboardingContent();
      this.setShowOnboardingOnPage(true);
      return this.showOnboarding = true;
    }
    if (flow === 'upsell') {
      const shouldShow = this.aboutThisPageService.checkIfShouldShowAboutThisPage(flow);
      if (!shouldShow) {
        return this.showOnboarding = false;
      }
      this.flow = flow;
      this.page = flow;
      this.refreshOnboardingContent();
      this.setShowOnboardingOnPage(true);
      return this.showOnboarding = true;
    }
    if (flow === 'schedule') {
      const hasProperties = await this.checkIfHasProperties();
      if (!hasProperties) {
        this.page = 'property';
        this.flow = 'schedule';
        this.setShowOnboardingOnPage(true);
        this.refreshOnboardingContent();
        return this.showOnboarding = true;
      } else {
        return this.showOnboarding = false;
      }
    }
    const onboardingGoals = await this.storage.retrieve('onboardingGoals');
    onboardingGoals.map((goal) => {
      goal.user_goal_steps.map((step) => {
        if (step.flow === flow && step.state === 'done') {
          showOnboarding = false;
        }
      })
    })
    if (showOnboarding) {
      this.flow = flow;
      this.page = flow;
      this.refreshOnboardingContent();
      this.setShowOnboardingOnPage(true);
    }
    return this.showOnboarding = showOnboarding;
  }

  async checkIfHasProperties() {
    const properties = await this.client.getMoreDetailAddresses(false);
    return properties.length > 0;
  }

  setShowOnboardingInDashboard(show: boolean) {
    this.showOnboardingInDashboard$.next(show);
  }

  getShowOnboardingInDashboard() {
    return this.showOnboardingInDashboard$.asObservable();
  }

  setShowOnboardingInHeader(show: boolean) {
    this.showOnboardingInHeader$.next(show);
  }

  getShowOnboardingInHeader() {
    return this.showOnboardingInHeader$.asObservable();
  }

  setShowOnboardingOnPage(show: boolean) {
    if (this.showOnboardingOnPage$.getValue() !== show) {
      this.showOnboardingOnPage$.next(show);
    }
  }

  getShowOnboardingOnPage() {
    return this.showOnboardingOnPage$.asObservable();
  }

  getGoalsToPickList() {
    const url = 'api/v1/customer/user-goal-types?include=user_goal_type_steps';
    return this.httpClient.get(url);
  }

  saveChosenGoals(goals) {
    const url = 'api/v1/customer/user-goals/create-many';
    return this.httpClient.post(url, goals);
  }

  updateChosenGoal(payload, goalId) {
    const url = `api/v1/customer/user-goals/${goalId}`;
    return this.httpClient.put(url, payload);
  }

  createAdvancedStep(payload) {
    const url = `api/v1/customer/user-goal-steps/advanced`;
    return this.httpClient.post(url, payload);
  }

  async getGoalsFromServer() {
    const url = 'api/v1/customer/user-goals?includes=user_goal_type,user_goal_steps,user_goal_type_step';
    const response = await this.httpClient.get(url);
    if (response.length === 0) {
      return;
    }
    const parsedGoals = await this.parseGoals(response);
    await this.storage.save('onboardingGoals', parsedGoals.filter((goal) => goal.chosen && goal.user_goal_type.title !== 'Advanced'));
    await this.storage.save('advancedOnboardingGoals', parsedGoals.filter((goal) => goal.user_goal_type.title === 'Advanced'));
  }

  async parseGoals(goals) {
    goals = this.removeNonV1Steps(goals);
    goals.map((goal) => {
      goal['isOpened'] = false;
      goal['icon'] = this.getGoalIcon(goal?.title || goal.user_goal_type.title);
      let completedSteps = 0;
      goal.user_goal_steps.map((step) => {
        const stepData = this.getStepData(step.title);
        step['page'] = stepData?.pageLink;
        step['flow'] = stepData?.flow;
        step['openMode'] = stepData?.openMode;
        step['tags'] = stepData?.tag;
        if (step.state === 'done') {
          completedSteps++;
        }
      });
      goal['completedSteps'] = completedSteps;
    });
    return goals;
  }

  removeNonV1Steps(goals) {
    const skipSteps = ['Handle Tasks for You', 'Schedule Automation', 'Notifications', 'Restocking Automation'];
    goals.map((goal) => {
      goal.user_goal_steps = goal.user_goal_steps.filter((step) => !skipSteps.includes(step.title));
    })
    return goals;
  }


  async checkIfDidFinishToDosOnboarding() {
    const onboardingGoals = await this.storage.retrieve('onboardingGoals');
    if (!onboardingGoals) {
      return true;
    }
    let didFinish = false;
    onboardingGoals.map((goal) => {
      goal.user_goal_steps.map((step) => {
        if (step.flow === 'toDos' && step.state === 'done') {
          didFinish = true;
        }
      })
    })
    return didFinish;
  }

  getGoalIcon(goalTitle: string) {
    const goalIcons = {
      'Automate Scheduling': 'assets/img/automate-turnovers.svg',
      'Automate Restocking': 'assets/img/automate-restocking.svg',
      'Automate Maintenance Triage': 'assets/img/smarter-maintenance.svg',
      'Automate Bills': 'assets/img/menu-bills-white.svg',
      'Automate Upsells': 'assets/img/enable-upsells.svg',
      'Automate Job Quality Checks': 'assets/img/improve-job-quality.svg',
      'Automate Pro Messaging': 'assets/img/chat-white.svg',
      'Automate Regular Maintenance': 'assets/img/smarter-maintenance.svg',
      'Notify Pros of Change': 'assets/img/menu-messages-white.svg',
    };
    return goalIcons[goalTitle];
  }

  getStepData(stepTitle: string) {
    const stepData = {
      'Integrate': {
        flow: 'selectIntegration',
        pageLink: 'integration/all',
        tag: {
          text: 'Recommended',
          class: 'recommended-tag',
        }
      },
      'Automatic scheduling settings': {
        flow: 'enableAutomaticBooking',
        pageLink: 'automations/summary',
      },
      'Add access notes': {
        flow: 'selectAccessNotes',
        pageLink: 'properties',
      },
      'Add pros': {
        flow: 'addPros',
        pageLink: 'contacts',
      },
      'Set up find new pros': {
        flow: 'selectFindNewPros',
        pageLink: 'automations/summary',
      },
      'Set up scheduling agent': {
        flow: 'scheduleAgent',
        pageLink: 'schedule',
      },
      'Add inventory': {
        flow: 'inventoryAutomation',
        pageLink: 'inventory',
      },
      'Set up restocking agent': {
        flow: 'restockingAgent',
        pageLink: 'inventory',
      },
      'Set up triage agent': {
        flow: 'restockingAgent',
        pageLink: 'maintenance',
      },
      'Set up billing agent': {
        flow: 'billsAgent',
        pageLink: 'bills',
      },
      /*'Integrate': {
        flow: 'integrateUpsell',
        pageLink: 'integration/all',
        tag: {
          text: 'Recommended',
          class: 'recommended-tag',
        }
      },*/
      'Set up upsell agent': {
        flow: 'upsellsAgent',
        pageLink: 'upsells',
      },
      'Create checklists': {
        flow: 'toDos',
        pageLink: 'checklists',
      },
      'Set up checklist agent': {
        flow: 'checklistAgent',
        pageLink: 'checklists',
      },
      'Set up messaging agent': {
        flow: 'messageAgent',
        pageLink: 'messages',
      },
      'Add smart number (recommended)': {
        flow: 'enableGuestSmartNumber',
        pageLink: 'messages',
      },
      'Automate Messages': {
        flow: 'messageAutomation',
        pageLink: 'messages',
      },
      'Add assets': {
        flow: 'selectMaintenance',
        pageLink: 'assets',
      },
      'Notify pros of change': {
        flow: 'notifyProsOfChange',
        pageLink: 'properties',
      },
      'Add recurring maintenance': {
        flow: 'addRecurringMaintenance',
        pageLink: 'recurring-maintenance',
      }
    }
    return stepData[stepTitle];
  }

  async markGoalAsCompleted(flow: string) {
    const goals = await this.storage.retrieve('onboardingGoals');
    if (!goals) {
      return;
    }
    const stepIDs: any[] = [];
    goals.map((goal) => {
      goal.user_goal_steps.map((step) => {
        if (step.flow === flow && step.state !== 'done') {
          stepIDs.push(step.id);
        }
      })
    });
    if (stepIDs.length === 0) {
      return;
    }
    const promises = stepIDs.map((stepID) => {
      const url = `api/v1/customer/user-goal-steps/${stepID}/mark-as-done`;
      return this.httpClient.post(url, {});
    });
    await Promise.all(promises);
    await this.getGoalsFromServer();
  }


  markAdvancedStepAsDone(stepID) {
    const url = `api/v1/customer/user-goal-steps/${stepID}/mark-as-done`;
    return this.httpClient.post(url, {});
  }

}

const flowText = {
  goals: {
    title: 'Getting Started',
    subTitle: 'Complete goals to unlock features.'
  },
  messageAutomation: {
    title: 'Getting Started: Message Automation',
    subTitle: 'View messages from pros and automate responses following your rules.',
    description: 'View messages from pros and automate responses following your rules.',
    buttonText: 'OK'
  },
  toDos: {
    title: 'Getting Started: Checklists',
    subTitle: 'Jobs get done right with digital checklists. Easily share. No download or signup required.',
    subTitleBeforeProperties: 'Please add your properties before setting up checklists.',
    description: 'Jobs get done right with digital checklists. Easily share. No download or signup required.',
    buttonText: 'Set Up Checklists'
  },
  tasks: {
    title: 'Getting Started: Tasks',
    subTitle: 'Track maintenance tasks & suggestions. Have the Concierge get them done for you.',
    description: 'Track maintenance tasks & suggestions. Have the Concierge get them done for you.',
    buttonText: 'Create a Task'
  },
  inventoryAutomation: {
    title: 'Getting Started: Restocking Automation',
    subTitle: 'Automate restocking of things like soaps, coffee, toilet paper, & more.',
    subTitleBeforeProperties: 'Please add your properties before setting up restocking.',
    description: 'Automate restocking of things like soaps, coffee, toilet paper, & more.',
    buttonText: 'Automate Restocking'
  },
  maintenance: {
    title: 'Getting Started: Maintenance',
    subTitle: 'Smart maintenance suggestions custom to you. What to do, what to skip, & how to save.',
    description: 'Smart maintenance suggestions custom to you. What to do, what to skip, & how to save.',
    buttonText: 'Set Up Smart Maintenance'
  },
  bills: {
    title: 'Getting Started: Bills',
    subTitle: 'Set up rules to pay pros on autopilot.',
    description: 'Set up rules to pay pros on autopilot.',
    buttonText: 'OK'
  },
  addPros: {
    title: 'Getting Started: Add Your Pros',
    subTitle: 'Use TIDY with any pro. If they don\'t use TIDY, we can automate via SMS or phone.',
    subTitleBeforeProperties: 'Please add your properties before adding your pros.',
    description: 'Use TIDY with any pro. If they don\'t use TIDY, we can automate via SMS or phone.',
    buttonText: 'Add Your Pros'
  },
  selectIntegration: {
    title: 'Getting Started: Integrate',
    subTitle: 'Integrate your favorite tools to streamline your operations.',
    description: 'Integrate your favorite tools to streamline your operations.',
    buttonText: 'Add Integration'
  },
  schedule: {
    title: 'Getting Started: Schedule',
    subTitle: 'Add your properties to get started.',
    description: 'Add your properties to get started.',
    buttonText: 'Add Properties'
  },
  automateWorkflows: {
    title: 'Getting Started: Automate Workflows',
    subTitle: 'Start with popular time saving automations based on triggers.',
    description: 'Start with popular time saving automations based on triggers.',
    buttonText: 'Automate Workflows'
  },
  upsell: {
    title: 'Getting Started: Upsell',
    subTitle: 'Enable automated handling of early check-in, late check-out, and mid-stay clean requests.',
    description: 'Enable automated handling of early check-in, late check-out, and mid-stay clean requests.',
    buttonText: 'Get Started Upselling'
  },
  selectFindNewPros: {
    title: 'Getting Started: Find New Pros',
    subTitle: 'If your pros can\'t make it, TIDY can help find you pros matching your settings.',
    description: 'If your pros can\'t make it, TIDY can help find you pros matching your settings.',
    buttonText: 'Find New Pros'
  },
  selectAccessNotes: {
    title: 'Getting Started: Access Notes',
    subTitle: 'Let your pros know how to get in.',
    subTitleBeforeProperties: 'Please add your properties before adding access notes.',
    description: 'Let your pros know how to get in.',
    buttonText: 'Add Access Notes'
  },
  selectMaintenance: {
    title: 'Getting Started: Add Assets',
    subTitle: 'Add appliances or other assets to track maintenance and get suggestions.',
    subTitleBeforeProperties: 'Please add your properties before adding maintenance items.',
    description: 'Add appliances or other assets to track maintenance and get suggestions.',
    buttonText: 'Add Assets'
  },
  addRecurringMaintenance: {
    title: 'Getting Started: Recurring Maintenance',
    subTitle: 'Set up recurring maintenance tasks to keep your properties in top condition.',
    subTitleBeforeProperties: 'Please add your properties before setting up recurring maintenance.',
    description: 'Schedule recurring maintenance tasks like HVAC filter changes, gutter cleaning, and more.',
    buttonText: 'Add Recurring Maintenance'
  },
  addInspections: {
    title: 'Getting Started: Add Inspections',
    subTitle: 'Use remote or in-person inspections to make sure jobs are done right.',
    description: 'Use remote or in-person inspections to make sure jobs are done right.',
    buttonText: 'Add Inspections'
  },
  enableAutomaticBooking: {
    title: 'Getting Started: Auto-Schedule',
    subTitle: 'Schedule your turnovers between guests/tenants on autopilot.',
    subTitleBeforeProperties: 'Please add your properties before setting up auto-schedule.',
    description: 'Schedule your turnovers between guests/tenants on autopilot.',
    buttonText: 'Set Up Auto-Schedule'
  },
  createConciergeRules: {
    title: 'Getting Started: Create Concierge Rules',
    subTitle: 'Create rules for our concierge to follow.'
  },
  notifyProsOfChange: {
    title: 'Getting Started: Notify Pros of Change',
    subTitle: 'Set up notifications to keep your pros informed of changes.',
    description: 'Set up automated notifications to keep your pros informed of schedule changes and updates.',
    buttonText: 'Set Up Notifications'
  },
  restockingAgent: {
    title: 'Restock Agent',
    subTitle: 'Automatically restock low inventory items.'
  },
  scheduleAgent: {
    title: 'Schedule Agent',
    subTitle: 'Track all cleanings, maintenance, and reservations in realtime.'
  },
  messageAgent: {
    title: 'Message Agent',
    subTitle: 'View messages from pros and automate responses following your rules.'
  },
  jobQualityAgent: {
    title: 'Job Quality Agent',
    subTitle: 'Improve job quality by automating tasks and reminders.'
  },
  maintenanceAgent: {
    title: 'Triage Agent',
    subTitle: 'Smart maintenance suggestions custom to you. What to do, what to skip, & how to save.'
  },
  issuesAgent: {
    title: 'Issues Agent',
    subTitle: 'Track maintenance tasks & suggestions. Have the Concierge get them done for you.'
  },
  billsAgent: {
    title: 'Bill Agent',
    subTitle: 'Set up rules to pay pros on autopilot.'
  },
  upsellsAgent: {
    title: 'Upsell Agent',
    subTitle: 'Enable automated handling of early check-in, late check-out, and mid-stay clean requests.'
  },
  myProsAgent: {
    title: 'Pro Agent',
    subTitle: 'Use TIDY with any pro. If they don\'t use TIDY, we can automate via SMS or phone.'
  },
  customizeServiceNames: {
    title: 'Getting Started: Customize Service Names',
    subTitle: 'Customize how service names appear to you throughout the app.',
    description: 'Customize how service names appear to you throughout the app. This helps you identify services more easily in your schedule, checklists, and reports.',
    buttonText: 'Customize Service Names'
  }

  /*

  Skipping for v1 but can still add text Chris if you want:

  schedule: {
  title: 'Schedule',
  subTitle: 'Track all cleanings, maintenance, and reservations in realtime.',
  description: 'Track all cleanings, maintenance, and reservations in realtime.',
  buttonText: 'Automate or Book Jobs'

  },*/

}
